// extracted by mini-css-extract-plugin
export default {"window":"newAddress_window__kyYFE","shortInput":"newAddress_shortInput__NVA31","newAddressBtn":"newAddress_newAddressBtn__jTAmV"};